import { render, staticRenderFns } from "./MessageWidgetMessage.vue?vue&type=template&id=6607e9be&scoped=true&"
import script from "./MessageWidgetMessage.vue?vue&type=script&lang=js&"
export * from "./MessageWidgetMessage.vue?vue&type=script&lang=js&"
import style0 from "./MessageWidgetMessage.vue?vue&type=style&index=0&id=6607e9be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6607e9be",
  null
  
)

export default component.exports